<template>
  <SdzModal
    ref="modal"
    @close="close"
    :close-icon="true"
    :width="$isMobile() ? '400' : '550'"
    custom-class="reprove-modal"
    hide-confirm-button
    hide-cancel-button
  >
    <v-layout
      align-center
      column
      justify-center
      wrap
      class="pt-5 pb-2 px-5"
    >
      <img
        :src="require(`@/assets/images/icons/info.svg`)"
        class="mb-4"
        width="70"
      >
      <span class="modal-title">
        Tem certeza que deseja reprovar a revisão da nota?
      </span>
      <div class="reprove-form">
        <AppTextArea
          v-model="reason"
          :rows="3"
          :v="$v.reason"
          label="Motivo: "
          placeholder="Justifique o motivo da reprovação"
          min-length="20"
          max-length="1000"
          hide-details
        />
        <p class="counter mt-1 mb-0">
          {{ (reason || '').length }} de 1000
        </p>
        <p class="counter">
          *Mínimo 20 caracteres.
        </p>
      </div>
    </v-layout>
    <template #buttons>
      <v-btn
        @click="close"
        color="primary"
        class="mb-3"
        outline
        flat
        large
      >
        Cancelar
      </v-btn>
      <v-btn
        @click="reprove"
        color="primary"
        class="mb-3"
        large
      >
        Sim, reprovar revisão
      </v-btn>
    </template>
  </SdzModal>
</template>

<script>
import SdzModal from '@/components/sdz/SdzModal.vue'
import AppTextArea from '@/components/ui/inputs/AppTextArea.vue'
import { rejectInvoiceReview } from '@/services/containers/partners/invoices'
import { 
  required,
  minLength, 
  maxLength
} from 'vuelidate/lib/validators'

export default {
  name: 'ReproveInvoiceReviewModal',
  components: {
    SdzModal,
    AppTextArea
  },
  props: {
    reviewId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      reason: null
    }
  },
  methods: {
    open() {
      this.$refs.modal.open()
      this.resetForm()
    },
    close() {
      this.$emit('close')
      this.$refs.modal.close()
    },
    resetForm() {
      this.reason = null
      this.$v.$reset()
    },
    async reprove() {
      try {
        this.$v.$touch()
        if (this.$v.$invalid) return
        await rejectInvoiceReview(this.reviewId, { description: this.reason })
        this.$toast('Solicitação reprovada com sucesso', 'green')
        this.$emit('reviewReproved')
        this.$refs.modal.close()

      } catch (error) {
        this.$toast(error.response.data.message, 'red')
        this.close()
      }
    }
  },
  validations() {
    return {
      reason: {
        required,
        minLength: minLength(20), 
        maxLength: maxLength(1000)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .reprove-modal {
    .modal-title {
      font-size: 28px;
      color: var(--v-gray-darken2);
      text-align: center;
    }

    .modal-text {
      font-size: 18px;
      color: var(--v-gray-darken2);
    }
    .reprove-form {
      margin-top: 24px;
      width: 100%;
    }

    .counter {
      font-size: 12px;
      color: var(--v-gray-darken2)
    }
  }
</style>